// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.clp-item {
  border: 1px solid rgb(29, 126, 236);
  cursor: pointer;
  padding: 2%;
  margin: 1% 0;
}

.clp-filter-container {
  padding: 10px;
  /* border: 1px solid black; */
  margin: 10px;
  width: 100%;
}

.modal-wrapper {
  height: 70%;
  overflow-y: scroll;
}

.clp-param-inp {
  margin: 5px 0;
}

.btn2 {
  margin: 5px;
}
.margin-10 {
  margin: 10px;
}

.errd-txt {
  color: red;
}

.clp-json-container {
  width: 100%;
}

.clp-single-filter {
  margin: 10px;
  padding: 10px;
  border: 1px solid black;
}

.search-clp {
  height: 31px;
  width: 300px;
}

.plp-card {
  padding: 6px;
  position: relative;
  max-height: 420px;
  margin-bottom: 15px;
}

.img-wrapper {
  height: 200px;
}

.img-wrapper .plp-img {
  -o-object-fit: cover;
  object-fit: cover;
  height: 200px;
  border-radius: 6px;
  width: 100%;
  position: relative;
}

.plp-cost {
  display: inline-block;
}

.plp-cost .actual-cost {
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
}

.plp-cost .cost-data {
  text-align: right;
  display: inline-block;
  padding-left: 10px;
}

.plp-cost .cost-data span.originalCost {
  color: #6d6d7a;
}

.plp-cost .cost-data span {
  margin: 0 3px;
  line-height: 1.64;
  color: #f05a9b;
}
.width-full {
  width: 100%;
}

.clp-error {
  font-size: 12px;
  color: red;
}

.search-but {
  background: #9F2089;
  color: white;
  font-weight: bold;
  letter-spacing: 1px;
  margin: 10px;
}

.float-r {
  float: right;
}

/* CVF Catalog Modal Styles */

.cvf-catalog-btn {
  background: #9F2089;
  color: white;
  font-weight: bold;
  letter-spacing: 1px;
  margin: 10px;
}

.catalog-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.catalog-item {
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  text-align: center;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}

.catalog-item:hover {
  background: #e3f2fd;
  border-color: #9F2089;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./client/components/dashboard/CLPAdmin/clpAdmin.css"],"names":[],"mappings":";;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,6BAA6B;;AAE7B;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,wCAAwC;AAC1C","sourcesContent":["\n\n.clp-item {\n  border: 1px solid rgb(29, 126, 236);\n  cursor: pointer;\n  padding: 2%;\n  margin: 1% 0;\n}\n\n.clp-filter-container {\n  padding: 10px;\n  /* border: 1px solid black; */\n  margin: 10px;\n  width: 100%;\n}\n\n.modal-wrapper {\n  height: 70%;\n  overflow-y: scroll;\n}\n\n.clp-param-inp {\n  margin: 5px 0;\n}\n\n.btn2 {\n  margin: 5px;\n}\n.margin-10 {\n  margin: 10px;\n}\n\n.errd-txt {\n  color: red;\n}\n\n.clp-json-container {\n  width: 100%;\n}\n\n.clp-single-filter {\n  margin: 10px;\n  padding: 10px;\n  border: 1px solid black;\n}\n\n.search-clp {\n  height: 31px;\n  width: 300px;\n}\n\n.plp-card {\n  padding: 6px;\n  position: relative;\n  max-height: 420px;\n  margin-bottom: 15px;\n}\n\n.img-wrapper {\n  height: 200px;\n}\n\n.img-wrapper .plp-img {\n  -o-object-fit: cover;\n  object-fit: cover;\n  height: 200px;\n  border-radius: 6px;\n  width: 100%;\n  position: relative;\n}\n\n.plp-cost {\n  display: inline-block;\n}\n\n.plp-cost .actual-cost {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.plp-cost .cost-data {\n  text-align: right;\n  display: inline-block;\n  padding-left: 10px;\n}\n\n.plp-cost .cost-data span.originalCost {\n  color: #6d6d7a;\n}\n\n.plp-cost .cost-data span {\n  margin: 0 3px;\n  line-height: 1.64;\n  color: #f05a9b;\n}\n.width-full {\n  width: 100%;\n}\n\n.clp-error {\n  font-size: 12px;\n  color: red;\n}\n\n.search-but {\n  background: #9F2089;\n  color: white;\n  font-weight: bold;\n  letter-spacing: 1px;\n  margin: 10px;\n}\n\n.float-r {\n  float: right;\n}\n\n/* CVF Catalog Modal Styles */\n\n.cvf-catalog-btn {\n  background: #9F2089;\n  color: white;\n  font-weight: bold;\n  letter-spacing: 1px;\n  margin: 10px;\n}\n\n.catalog-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  max-height: 300px;\n  overflow-y: auto;\n  margin-top: 20px;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n}\n\n.catalog-item {\n  background: #f5f5f5;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 12px;\n  text-align: center;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.catalog-item:hover {\n  background: #e3f2fd;\n  border-color: #9F2089;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
